import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormManifestationDetermination } from "../Models/Forms/IFormManifestationDetermination";
import { ILookupBase } from "../Models/ILookupBase";
import { BaseService } from './BaseService';

@Injectable()
export class FormManifestationDeterminationService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormManifestationDetermination(id: number) {
    return this._http.get(this._baseUrl + "api/FormManifestationDetermination/" + id)
      .map((response: IFormManifestationDetermination) => response as IFormManifestationDetermination)
      .catch(this.errorHandler);
  }

  getServiceProviderList() {
    return this._http.get(this._baseUrl + "api/FormManifestationDetermination/GetServiceProviderList/")
      .map((response: ILookupBase[]) => response as ILookupBase[])
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormManifestationDetermination/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  insertUpdateFormManifestationDetermination(formManifestationDeterminationDetails: IFormManifestationDetermination) {
    return this._http.post(this._baseUrl + 'api/FormManifestationDetermination', formManifestationDeterminationDetails)
      .map((response: IFormManifestationDetermination) => response as IFormManifestationDetermination)
      .catch(this.errorHandler);
  }

  deleteManifestationDetermination(id) {
    return this._http.delete(this._baseUrl + "api/FormManifestationDetermination" + id)
      .map((response: IFormManifestationDetermination) => response as IFormManifestationDetermination)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}


